























import { Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { MetaInfo } from 'vue-meta';
import { mapGetters, mapState } from 'vuex';
import { Route } from 'vue-router/types/router';
import {
  DailyChallenge,
  DcProblem,
  DcProblemLoggedOut,
  DcMainBody,
} from 'frontend/types/daily-challenges';
import { meta } from 'frontend/utils/decorators';

import DailyChallengeBase from './components/DailyChallengeBase.vue';
import DailyChallengeBody from './components/DailyChallengeBody.vue';
import DailyChallengeProblem from './components/DailyChallengeProblem.vue';
import DcSubscribePremium from './components/DcSubscribePremium.vue';
import setupKatex from 'frontend/views/lessons/utils/katex';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    DailyChallengeBase,
    DailyChallengeBody,
    DailyChallengeProblem,
    DcSubscribePremium,
  },
  computed: {
    ...mapState('dailyChallenges', ['dc', 'mainbody', 'problem']),
    ...mapGetters('dailyChallenges', ['isLocked']),
    ...mapGetters('globals', ['isAuthenticated']),
  },
})
export default class DailyChallengeView extends Vue {
  private dc!: DailyChallenge;
  private mainbody!: DcMainBody;
  private problem!: DcProblem | DcProblemLoggedOut;
  private isLoading = true;
  private readonly isAuthenticated!: boolean;

  private beforeRouteUpdate(to: Route, from: Route, next: (to?: any) => void): void {
    this.isLoading = true;
    next();
  }

  private async mounted() {
    if (process.env.VUE_ENV !== 'server') {
      this.$nextTick(() => {
        setupKatex();
      });
    }
  }

  @meta
  private metaInfo(): MetaInfo {
    return {
      title: `${this.dc.title} | Daily Challenge`,
      meta: [
        {
          name: 'description',
          content: `${this.dc.preview_copy}`,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `${this.dc.title} | Daily Challenge | Brilliant`,
        },
        { vmid: 'og:description', property: 'og:description', content: `${this.dc.preview_copy}` },
        { vmid: 'og:image', property: 'og:image', content: this.dc.image },
      ],
    };
  }

  @Watch('$route', { immediate: true, deep: true })
  private async onDailyChallengeView() {
    this.isLoading = false;
  }

  private get loggedInProblem(): DcProblem {
    return this.problem as DcProblem;
  }

  private get isCompleted() {
    if (this.isAuthenticated) {
      return this.loggedInProblem.completed;
    }
    return false;
  }
}
